export const SUPPORT_EMAIL = {
  value: 'contact@steto.care',
  label: 'contact@steto.care',
};
export const SUPPORT_PHONE = {
  value: '+33750522118',
  label: '+33 7 50 52 21 18',
};
